import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { ProgramProvider } from './contexts/ProgramContext';
import AppRoutes from './routes/AppRoutes';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <ProgramProvider>
          <Router>
            <AppRoutes />
          </Router>
        </ProgramProvider>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
